import getIcon from './utils/get-icon';

export default getIcon;
